export const UserRole = Object.freeze({
  DEALER_ADMIN: "1",
  SERVICE_DESK_USER: "2",
});

export default UserRole;
